module.exports = __webpack_public_path__ + "static/img/app-user.59aa97b7.png";